export const API_BASE = '/api'
export const API_BASE_AUTH = '/auth'
import * as loadingAnimation from '../../shared/components/loading.json'
import * as loadingAnimationDark from '../../shared/components/loading-dark.json'

export const LOADING_ANIMATION_OPTIONS = {
  animationData: loadingAnimation.default,
}
export const LOADING_ANIMATION_OPTIONS_DARK = {
  animationData: loadingAnimationDark.default,
}

export const ADMIN_ROLES = [
  {
    label: 'Full Access',
    value: 2,
  },
  {
    label: 'Connections Admin',
    value: 3,
  },
]

// NOTE: values are all strings because VueFormulate stupidly casts
// all integer values to strings, making comparison a pain in the ass.
export const LAYOUT_TYPES = [
  { label: 'Layout 1', value: '0' },
  { label: 'Layout 2', value: '1' },
  { label: 'Layout 3', value: '2' },
]

export const THEME_TYPES = [
  { label: 'Dark', value: '0' },
  { label: 'Light', value: '1' },
]

export const LEXEND_KEY = 'Lexend'
export const FONT_TITLE_TYPES = [
  { label: LEXEND_KEY, dataValue: LEXEND_KEY, value: '3' },
  { label: 'Alegreya', dataValue: 'Alegreya', value: '0' },
  { label: 'Oswald', dataValue: 'Oswald', value: '1' },
  { label: 'Baloo', dataValue: 'Baloo', value: '2' },
]

export const FONT_BODY_TYPES = [
  { label: LEXEND_KEY, dataValue: LEXEND_KEY, value: '4' },
  { label: 'Nunito', dataValue: 'Nunito', value: '0' },
  { label: 'Open Sans', dataValue: 'Open+Sans', value: '1' },
  { label: 'Montserrat', dataValue: 'Montserrat', value: '2' },
  { label: 'Lato', dataValue: 'Lato', value: '3' },
]

export const MENU_TYPES = [
  { label: 'Full', value: '0' },
  { label: 'Compact', value: '1' },
]

export const CATEGORY_TYPES = [
  { text: 'News', value: 1 },
  { text: 'Jobs', value: 2 },
  { text: 'Event', value: 3 },
]

export const JOB_TYPES = [
  { text: 'Part Time', value: 0 },
  { text: 'Full Time', value: 1 },
  { text: 'Casual', value: 2 },
  { text: 'Apprenticeship', value: 3 },
  { text: 'Volunteer', value: 4 },
]

export const POSTS_VIEW_OPTIONS = {
  DEFAULT: 'default',
  CALENDAR: 'calendar',
}

export const ALL_REGIONS_TAG_ID = 99
export const KEY_TYPE_REGION = 'region'

// CAREERWISE CONNECTIONS - FILTERS
export const FILTER_FORM_DEFAULT_VALUES = {
  dateYear: null,
  dateFrom: null,
  dateTo: null,
  industries: null,
  schoolSupport: null,
  preferences: null,
  organisationsSupport: null,
  subjects: null,
  engagementTypes: null,
  years: null,
  softSkills: null,
  techSkills: null,
  // NOTE: policeChecked: false is converted to null in the payload,
  // so toggling off effectively ignores that filter rather than
  // returns connections who aren't actually police checked
  policeChecked: false,
  keywords: null,
}

export const FILTER_FORM_LABEL_MAP = {
  dateYear: 'Selected year',
  dateFrom: 'Engagement date after',
  dateTo: 'Engagement date before',
  industries: 'Industries',
  schoolSupport: 'School support',
  preferences: 'Preferences',
  organisationsSupport: 'Career support areas',
  subjects: 'Learning areas',
  engagementTypes: 'Engagement types',
  years: 'Year levels',
  softSkills: 'Soft skills',
  techSkills: 'Technical skills',
  policeChecked: 'Police checked',
  keywords: 'Search',
}

// CAREERWISE CONTRIBUTORS RELATED
const KEY_DATE_RANGE = 'date range'
const KEY_DATE_RANGE_PAYLOAD = 'days'
const OPTIONS_DEFAULT = [
  {
    text: 'All time',
    value: 0,
  },
  {
    text: 'Last 30 days',
    value: 30,
  },
  {
    text: 'Last 60 days',
    value: 60,
  },
  {
    text: 'Last 90 days',
    value: 90,
  },
  {
    text: 'Last 365 days',
    value: 365,
  },
]
export const CD_STAT_TYPE_OPTIONS = {
  MAILOUTS: {
    TYPE: KEY_DATE_RANGE,
    KEY_PAYLOAD: KEY_DATE_RANGE_PAYLOAD,
    ACTION: 'dispatchUpdateStatsMailouts',
    OPTIONS: () => OPTIONS_DEFAULT,
  },

  TOP_POSTS: {
    TYPE: KEY_DATE_RANGE,
    KEY_PAYLOAD: KEY_DATE_RANGE_PAYLOAD,
    ACTION: 'dispatchUpdateStatsTopPosts',
    OPTIONS: () => OPTIONS_DEFAULT,
  },

  POST_SHARES: {
    TYPE: KEY_DATE_RANGE,
    KEY_PAYLOAD: KEY_DATE_RANGE_PAYLOAD,
    ACTION: 'dispatchUpdateStatsOrganisationPostShares',
    OPTIONS: () => OPTIONS_DEFAULT,
  },

  POST_REACH: {
    TYPE: KEY_DATE_RANGE,
    KEY_PAYLOAD: KEY_DATE_RANGE_PAYLOAD,
    ACTION: 'dispatchUpdateStatsOrganisationPostReach',
    OPTIONS: () => OPTIONS_DEFAULT,
  },

  SCHOOLS: {
    TYPE: KEY_TYPE_REGION,
    KEY_PAYLOAD: KEY_TYPE_REGION,
    ACTION: 'dispatchUpdateStatsSchools',
    OPTIONS: (store) => store.getters['shared/getTagsRegions'] || [],
  },
}
// Contributor statistics - posts
export const CD_POSTS_SORT_BY_OPTIONS = [
  {
    text: 'Post Date',
    value: 'created_at_desc',
    subtext: 'latest posts',
    selectedText: 'latest posts',
    sortBy: 'created_at',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Post Date',
    value: 'created_at_asc',
    subtext: 'oldest posts',
    selectedText: 'oldest posts',
    sortBy: 'created_at',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'School Shares',
    value: 'shares_desc',
    subtext: 'most',
    selectedText: 'most shares',
    sortBy: 'shares',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'School Shares',
    value: 'shares_asc',
    subtext: 'least',
    selectedText: 'least shares',
    sortBy: 'shares',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Post Reach',
    value: 'audience_desc',
    subtext: 'greatest',
    selectedText: 'greatest reach',
    sortBy: 'audience',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Post Reach',
    value: 'audience_asc',
    subtext: 'least',
    selectedText: 'least reach',
    sortBy: 'audience',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
]
// Contributor statistics - connections
export const CD_CONNECTIONS_SORT_BY_OPTIONS = [
  {
    text: 'Added Date',
    value: 'created_at_desc',
    subtext: 'latest connections',
    selectedText: 'latest connections',
    sortBy: 'created_at',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Added Date',
    value: 'created_at_asc',
    subtext: 'earliest connections',
    selectedText: 'earliest connections',
    sortBy: 'created_at',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Connection Views',
    value: 'displayed_desc',
    subtext: 'most',
    selectedText: 'most views',
    sortBy: 'displayed',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Connection Views',
    value: 'displayed_asc',
    subtext: 'least',
    selectedText: 'least views',
    sortBy: 'displayed',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Connections Leads',
    value: 'viewed_desc',
    subtext: 'most',
    selectedText: 'most leads',
    sortBy: 'viewed',
    orderBy: 'desc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 18a.75.75 0 0 1-.75-.75V4.66L7.3 6.76a.75.75 0 0 1-1.1-1.02l3.25-3.5a.75.75 0 0 1 1.1 0l3.25 3.5a.75.75 0 1 1-1.1 1.02l-1.95-2.1v12.59A.75.75 0 0 1 10 18Z" clip-rule="evenodd" />
          </svg>`,
  },
  {
    text: 'Connections Leads',
    value: 'viewed_asc',
    subtext: 'least',
    selectedText: 'least leads',
    sortBy: 'viewed',
    orderBy: 'asc',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M10 2a.75.75 0 0 1 .75.75v12.59l1.95-2.1a.75.75 0 1 1 1.1 1.02l-3.25 3.5a.75.75 0 0 1-1.1 0l-3.25-3.5a.75.75 0 1 1 1.1-1.02l1.95 2.1V2.75A.75.75 0 0 1 10 2Z" clip-rule="evenodd" />
          </svg>`,
  },
]

// EVENTBUS EVENTS (@todo WIP)
export const EVENT_KEYS = {
  CD_INPUT_DROPDOWN_UPDATED: 'cw-contributor-input-dropdown-updated',
  CO_VUE_FORMULATE_TAGS_UPDATED: 'cw-connections-vue-formulate-tags-updated',
  CO_VUE_FORMULATE_TAGS_TOGGLE_COLLAPSED:
    'cw-connections-vue-formulate-tags-toggle-collapse',
  CO_VUE_FORMULATE_TOGGLE_UPDATED:
    'cw-connections-vue-formulate-toggle-updated',
  CO_VUE_FORMULATE_FILTER_FORM_KEYWORDS_UPDATED:
    'cw-connections-vue-formulate-filter-form-keywords-updated',
  CO_VUE_FORMULATE_FILTER_FORM_DATE_UPDATED:
    'cw-connections-vue-formulate-filter-form-date-updated',
  CO_VUE_FORMULATE_FILTER_FORM_DATE_YEAR_UPDATED:
    'cw-connections-vue-formulate-filter-form-date-year-updated',
  CO_UPDATE_COMPONENT_PAGINATION: 'cw-connections-update-component-pagination',
  CO_UPDATE_COMPONENT_PAGINATION_REPORTS:
    'cw-connections-update-component-pagination-reports',
}

export default {
  ADMIN_ROLES,
  JOB_TYPES,
  POSTS_VIEW_OPTIONS,
  ALL_REGIONS_TAG_ID,
  KEY_TYPE_REGION,
  FILTER_FORM_DEFAULT_VALUES,
  FILTER_FORM_LABEL_MAP,
  CD_STAT_TYPE_OPTIONS,
  EVENT_KEYS,
}
